/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, fromEnum, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, delegateCombine, enumGetBox, delegateRemove, fromEn } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { ButtonGroupOrientation_$type } from "./ButtonGroupOrientation";
import { ButtonGroupDisplayStyle_$type } from "./ButtonGroupDisplayStyle";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { ButtonGroupButtonCollection } from "./ButtonGroupButtonCollection";
import { ThemeResolver } from "./ThemeResolver";
import { ButtonGroupSelectionChangedEventArgs } from "./ButtonGroupSelectionChangedEventArgs";
import { CornerRadius } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var ButtonGroupView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ButtonGroupView, _super);
    function ButtonGroupView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.f = new List$1(Delegate_$type, 0);
        _this.m = null;
        _this.c = true;
        _this.h = null;
        _this.i = null;
        _this.j = null;
        _this.k = null;
        return _this;
    }
    ButtonGroupView.prototype.s = function () {
    };
    ButtonGroupView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(ButtonGroupView.prototype, "l", {
        get: function () {
            return this.h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroupView.prototype, "y", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroupView.prototype, "e", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroupView.prototype.q = function (a) {
        var e_1, _a;
        var _this = this;
        if (a == null) {
            try {
                for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.f.clear();
        }
        this.g = a;
        a.rootWrapper.setStyleProperty("position", "relative");
        var c = this.g.createElement("div");
        c.addClass("ig-button-content");
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("display", "flex");
        c.setStyleProperty("flex-direction", "row");
        c.setStyleProperty("flex-wrap", "no-wrap");
        c.setStyleProperty("align-items", "center");
        this.j = c;
        this.f.add(c.listen("click", runOn(this, this.n)));
        this.g.append(c);
        this.g.getPortal(c, "ChildContent", function (d) {
            var comp_ = d.componentRef;
            _this.k = comp_;
            if (_this.a.q == 0) {
                _this.j.setStyleProperty("flex-direction", "row");
                comp_.display = 'flex';
                comp_.flexDirection = 'row';
            }
            else {
                _this.j.setStyleProperty("flex-direction", "column");
                comp_.display = 'flex';
                comp_.flexDirection = 'column';
            }
        }, true);
        this.a.c8();
    };
    ButtonGroupView.prototype.w = function (a) {
        if (this.m != a) {
            this.m = a;
            if (this.i != null) {
                this.i.setAttribute("d", this.m);
            }
        }
    };
    ButtonGroupView.prototype.v = function () {
        var comp_ = this.k;
        if (comp_ != null) {
            if (this.a.q == 0) {
                this.j.setStyleProperty("flex-direction", "row");
                comp_.display = 'flex';
                comp_.flexDirection = 'row';
            }
            else {
                this.j.setStyleProperty("flex-direction", "column");
                comp_.display = 'flex';
                comp_.flexDirection = 'column';
            }
        }
    };
    ButtonGroupView.prototype.n = function (a) {
    };
    ButtonGroupView.prototype.t = function () {
        if (this.d()) {
        }
    };
    ButtonGroupView.prototype.p = function () {
        this.c = true;
    };
    ButtonGroupView.prototype.r = function () {
        var e_2, _a;
        this.c = false;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.f.clear();
    };
    ButtonGroupView.prototype.x = function (a) {
        if (a != null) {
            this.g.rootWrapper.setStyleProperty("font", a.fontString);
        }
    };
    ButtonGroupView.prototype.u = function (a) {
        if (this.a.q == 0) {
            a.f5 = "flex";
            a.g7 = "row";
            a.fp = "center";
        }
        else {
            a.f5 = "flex";
            a.g7 = "column";
            a.fp = "stretch";
        }
    };
    ButtonGroupView.prototype.o = function (a) {
        this.j.append(a);
    };
    ButtonGroupView.$t = markType(ButtonGroupView, 'ButtonGroupView');
    return ButtonGroupView;
}(Base));
export { ButtonGroupView };
/**
 * @hidden
 */
var ButtonGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super.call(this) || this;
        _this.n = 1;
        _this.e = 0;
        _this.i = 1;
        _this.h = 1;
        _this.a = new Array(0);
        _this.t = false;
        _this._view = null;
        _this.aw = ThemeResolver.b(ButtonGroup.f, ButtonGroup.au, ButtonGroup.ao);
        _this.gw = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gk, ButtonGroup.fk);
        _this.gy = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gm, ButtonGroup.fm);
        _this.gx = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gl, ButtonGroup.fl);
        _this.gz = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gn, ButtonGroup.fn);
        _this.av = ThemeResolver.b(ButtonGroup.f, ButtonGroup.at, ButtonGroup.an);
        _this.g3 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gr, ButtonGroup.fr);
        _this.g0 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.go, ButtonGroup.fo);
        _this.g4 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gs, ButtonGroup.fs);
        _this.g7 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gv, ButtonGroup.fv);
        _this.g1 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gp, ButtonGroup.fp);
        _this.g2 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gq, ButtonGroup.fq);
        _this.g5 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gt, ButtonGroup.ft);
        _this.g6 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gu, ButtonGroup.fu);
        _this.aq = ThemeResolver.b(ButtonGroup.f, ButtonGroup.as, ButtonGroup.am);
        _this.fw = ThemeResolver.e(ButtonGroup.f, ButtonGroup.f8, ButtonGroup.e8);
        _this.fy = ThemeResolver.e(ButtonGroup.f, ButtonGroup.ga, ButtonGroup.fa);
        _this.fx = ThemeResolver.e(ButtonGroup.f, ButtonGroup.f9, ButtonGroup.e9);
        _this.fz = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gb, ButtonGroup.fb);
        _this.ap = ThemeResolver.b(ButtonGroup.f, ButtonGroup.ar, ButtonGroup.al);
        _this.f3 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gf, ButtonGroup.ff);
        _this.f0 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gc, ButtonGroup.fc);
        _this.f4 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gg, ButtonGroup.fg);
        _this.f7 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gj, ButtonGroup.fj);
        _this.f1 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gd, ButtonGroup.fd);
        _this.f2 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.ge, ButtonGroup.fe);
        _this.f5 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gh, ButtonGroup.fh);
        _this.f6 = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gi, ButtonGroup.fi);
        _this.ac = ThemeResolver.b(ButtonGroup.f, ButtonGroup.au, ButtonGroup.ao);
        _this.dj = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gk, ButtonGroup.fk);
        _this.dl = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gm, ButtonGroup.fm);
        _this.dr = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gr, ButtonGroup.fr);
        _this.dn = ThemeResolver.e(ButtonGroup.f, ButtonGroup.go, ButtonGroup.fo);
        _this.dk = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gl, ButtonGroup.fl);
        _this.dm = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gn, ButtonGroup.fn);
        _this.ab = ThemeResolver.b(ButtonGroup.f, ButtonGroup.at, ButtonGroup.an);
        _this.ds = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gs, ButtonGroup.fs);
        _this.dv = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gv, ButtonGroup.fv);
        _this.dp = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gp, ButtonGroup.fp);
        _this.dq = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gq, ButtonGroup.fq);
        _this.dt = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gt, ButtonGroup.ft);
        _this.du = ThemeResolver.e(ButtonGroup.f, ButtonGroup.gu, ButtonGroup.fu);
        _this.ag = NaN;
        _this.d4 = null;
        _this.d6 = null;
        _this.eb = null;
        _this.d8 = null;
        _this.d9 = null;
        _this.d5 = null;
        _this.d7 = null;
        _this.af = NaN;
        _this.ea = null;
        _this.es = null;
        _this.ev = null;
        _this.et = null;
        _this.eu = null;
        _this.ai = NaN;
        _this.ec = null;
        _this.ee = null;
        _this.ej = null;
        _this.eg = null;
        _this.eh = null;
        _this.ed = null;
        _this.ef = null;
        _this.ah = NaN;
        _this.ei = null;
        _this.eo = null;
        _this.er = null;
        _this.ep = null;
        _this.eq = null;
        _this.ae = NaN;
        _this.dw = null;
        _this.dy = null;
        _this.d3 = null;
        _this.d0 = null;
        _this.d1 = null;
        _this.dx = null;
        _this.dz = null;
        _this.ad = NaN;
        _this.d2 = null;
        _this.ek = null;
        _this.en = null;
        _this.el = null;
        _this.em = null;
        _this.p = 0;
        _this.a4 = "ig-buttongroup-" + ButtonGroup.a3++;
        _this.v = false;
        _this.u = false;
        _this.w = false;
        _this.propertyChanged = null;
        _this.l = new ButtonGroupButtonCollection();
        _this.selectionChanged = null;
        var a = new ButtonGroupView();
        a.a = _this;
        _this.view = a;
        _this.view.s();
        var b = _this.l;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.c0));
        var c = _this.l;
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.c1));
        return _this;
    }
    Object.defineProperty(ButtonGroup.prototype, "o", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.c7("DisplayType", enumGetBox(ButtonGroupDisplayStyle_$type, b), enumGetBox(ButtonGroupDisplayStyle_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "g", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.c7("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.prototype.c1 = function (a, b) {
        var e_3, _a;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.buttons)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.clicked = delegateRemove(c.clicked, runOn(this, this.c3));
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        this.dc();
    };
    ButtonGroup.prototype.appendContentChild = function (a) {
        this.view.o(a);
    };
    ButtonGroup.prototype.c0 = function (a, b) {
        var e_4, _a, e_5, _b;
        if (b.oldItems != null) {
            try {
                for (var _c = tslib_1.__values(fromEn(b.oldItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    var d = c;
                    if (d != null) {
                        d.clicked = delegateRemove(d.clicked, runOn(this, this.c3));
                    }
                }
            }
            catch (e_4_1) {
                e_4 = { error: e_4_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_4)
                        throw e_4.error;
                }
            }
        }
        if (b.newItems != null) {
            try {
                for (var _e = tslib_1.__values(fromEn(b.newItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var e = _f.value;
                    var f = e;
                    if (f != null) {
                        f.clicked = delegateCombine(f.clicked, runOn(this, this.c3));
                    }
                }
            }
            catch (e_5_1) {
                e_5 = { error: e_5_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_5)
                        throw e_5.error;
                }
            }
        }
        this.dc();
    };
    ButtonGroup.prototype.c3 = function (a, b) {
        var c = a;
        var d = this.buttons.indexOf(c);
        this.db(c, d);
    };
    Object.defineProperty(ButtonGroup.prototype, "k", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            if (b != this.i) {
                this.c7("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "j", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            var b = this.h;
            this.h = a;
            if (b != this.h) {
                this.c7("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "d", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.c7("SelectedIndices", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.prototype.db = function (a, b) {
        this.t = true;
        if (this.z(a)) {
            this.d = this.b(this.d, a, b);
        }
        else {
            if (!this.y) {
                this.d = new Array(0);
            }
            this.d = this.c(this.d, a, b);
        }
        this.dc();
        if (this.selectionChanged != null) {
            this.selectionChanged(this, new ButtonGroupSelectionChangedEventArgs());
        }
        this.t = false;
    };
    ButtonGroup.prototype.c = function (a, b, c) {
        var d = new Array(Math.max(0, this.a.length + 1));
        var e = 0;
        for (var f = 0; f < this.a.length; f++) {
            if (this.a[f] != c) {
                d[e] = this.a[f];
                e++;
            }
        }
        d[e] = c;
        return d;
    };
    ButtonGroup.prototype.b = function (a, b, c) {
        var d = new Array(Math.max(0, this.a.length - 1));
        var e = 0;
        for (var f = 0; f < this.a.length; f++) {
            if (this.a[f] != c) {
                d[e] = this.a[f];
                e++;
            }
        }
        return d;
    };
    Object.defineProperty(ButtonGroup.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.prototype.destroy = function () {
        this.provideContainer(null);
    };
    ButtonGroup.prototype.c7 = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.c9(a, b, c);
    };
    ButtonGroup.prototype.c9 = function (a, b, c) {
        switch (a) {
            case "BaseTheme":
                this.de(this.g);
                this.dd();
                break;
            case "DisplayType":
            case "ItemBorderColor":
            case "ItemDisabledBorderColor":
            case "ItemBackgroundColor":
            case "ItemDisabledBackgroundColor":
            case "SelectedItemBackgroundColor":
            case "ItemTextColor":
            case "ItemDisabledTextColor":
            case "SelectedItemTextColor":
            case "ItemHoverBackgroundColor":
            case "SelectedItemHoverBackgroundColor":
            case "ItemHoverTextColor":
            case "SelectedItemHoverTextColor":
            case "OutlinedItemBorderColor":
            case "OutlinedItemDisabledBorderColor":
            case "OutlinedItemBackgroundColor":
            case "OutlinedItemDisabledBackgroundColor":
            case "OutlinedSelectedItemBackgroundColor":
            case "OutlinedItemTextColor":
            case "OutlinedItemDisabledTextColor":
            case "OutlinedSelectedItemTextColor":
            case "OutlinedItemHoverBackgroundColor":
            case ButtonGroup.cs:
            case "OutlinedItemHoverTextColor":
            case "OutlinedSelectedItemHoverTextColor":
            case "FlatItemBorderColor":
            case "FlatItemDisabledBorderColor":
            case "FlatItemBackgroundColor":
            case "FlatItemDisabledBackgroundColor":
            case "FlatSelectedItemBackgroundColor":
            case "FlatItemTextColor":
            case "FlatItemDisabledTextColor":
            case "FlatSelectedItemTextColor":
            case "FlatItemHoverBackgroundColor":
            case "FlatSelectedItemHoverBackgroundColor":
            case "FlatItemHoverTextColor":
            case "FlatSelectedItemHoverTextColor":
                this.dd();
                break;
            case "ActualItemBorderColor":
            case "ActualItemDisabledBorderColor":
            case "ActualItemDisabledBackgroundColor":
            case "ActualItemBackgroundColor":
            case "ActualItemTextColor":
            case "ActualItemDisabledTextColor":
            case "ActualSelectedItemTextColor":
            case "ActualSelectedItemBackgroundColor":
                this.dc();
                break;
            case "Orientation":
                this.view.v();
                this.dc();
                break;
            case "Density":
                this.j = this.k == 0 ? 1 : this.k;
                break;
            case "ActualDensity":
                for (var d = 0; d < this.buttons.count; d++) {
                    this.buttons._inner[d].h = this.j;
                }
                break;
            case "IsDisabled":
                for (var e = 0; e < this.buttons.count; e++) {
                    this.buttons._inner[e].disabled = this.disabled;
                }
                break;
            case "SelectedIndices":
                if (!this.t) {
                    this.dc();
                }
                break;
        }
    };
    ButtonGroup.prototype.di = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    ButtonGroup.prototype.dd = function () {
        switch (this.o) {
            case 1:
                this.ak = !isNaN_(this.a0) ? this.a0 : this.aw;
                this.ew = this.hk != null ? this.hk : this.gw;
                this.ey = this.hm != null ? this.hm : this.gy;
                this.e3 = this.hr != null ? this.hr : this.g3;
                this.e0 = this.ho != null ? this.ho : this.g0;
                this.ex = this.hl != null ? this.hl : this.gx;
                this.ez = this.hn != null ? this.hn : this.gz;
                this.aj = !isNaN_(this.az) ? this.az : this.av;
                this.e4 = this.h4 != null ? this.h4 : this.g4;
                this.e7 = this.h7 != null ? this.h7 : this.g7;
                this.e1 = this.hp != null ? this.hp : this.g1;
                this.e2 = this.hq != null ? this.hq : this.g2;
                this.e5 = this.h5 != null ? this.h5 : this.g5;
                this.e6 = this.h6 != null ? this.h6 : this.g6;
                break;
            case 0:
                this.ak = !isNaN_(this.a0) ? this.a0 : this.aq;
                this.ew = this.hk != null ? this.hk : this.fw;
                this.ey = this.hm != null ? this.hm : this.fy;
                this.e3 = this.hr != null ? this.hr : this.f3;
                this.e0 = this.ho != null ? this.ho : this.f0;
                this.ex = this.hl != null ? this.hl : this.fx;
                this.ez = this.hn != null ? this.hn : this.fz;
                this.aj = !isNaN_(this.az) ? this.az : this.ap;
                this.e4 = this.h4 != null ? this.h4 : this.f4;
                this.e7 = this.h7 != null ? this.h7 : this.f7;
                this.e1 = this.hp != null ? this.hp : this.f1;
                this.e2 = this.hq != null ? this.hq : this.f2;
                this.e5 = this.h5 != null ? this.h5 : this.f5;
                this.e6 = this.h6 != null ? this.h6 : this.f6;
                break;
        }
    };
    ButtonGroup.prototype.dc = function () {
        for (var a = 0; a < this.buttons.count; a++) {
            var b = this.buttons._inner[a];
            b.h = this.j;
            if (a == 0) {
                this.df(b);
            }
            else if (a == this.buttons.count - 1) {
                this.dg(b);
            }
            else {
                this.dh(b);
            }
            b.r = 1;
            b.aj = false;
            if (this.u) {
                b.disabled = this.disabled;
            }
            b.nc = this.ex;
            b.au = this.aj;
            b.r8 = this.ez;
            b.r7 = this.ey;
            b.r9 = this.e0;
            this.view.u(b);
            if (this.z(b)) {
                b.nb = this.e4;
                b.ty = this.e7;
                b.sy = this.e5;
                b.sz = this.e6;
            }
            else {
                b.nb = this.ew;
                b.ty = this.e3;
                b.sy = this.e1;
                b.sz = this.e2;
            }
        }
    };
    ButtonGroup.prototype.z = function (a) {
        var b = this.buttons.indexOf(a);
        for (var c = 0; c < this.d.length; c++) {
            if (this.d[c] == b) {
                return true;
            }
        }
        return false;
    };
    ButtonGroup.prototype.dh = function (a) {
        a.j4 = new CornerRadius(1, 0, 0, 0, 0);
    };
    ButtonGroup.prototype.dg = function (a) {
        if (this.q == 1) {
            a.j4 = new CornerRadius(1, 0, 0, this.ak, this.ak);
        }
        else {
            a.j4 = new CornerRadius(1, 0, this.ak, this.ak, 0);
        }
    };
    ButtonGroup.prototype.df = function (a) {
        if (this.q == 1) {
            a.j4 = new CornerRadius(1, this.ak, this.ak, 0, 0);
        }
        else {
            a.j4 = new CornerRadius(1, this.ak, 0, 0, this.ak);
        }
    };
    ButtonGroup.prototype.de = function (a) {
        this.aw = ThemeResolver.b(a, ButtonGroup.au, ButtonGroup.ao);
        this.gw = ThemeResolver.e(a, ButtonGroup.gk, ButtonGroup.fk);
        this.gy = ThemeResolver.e(a, ButtonGroup.gm, ButtonGroup.fm);
        this.gx = ThemeResolver.e(a, ButtonGroup.gl, ButtonGroup.fl);
        this.gz = ThemeResolver.e(a, ButtonGroup.gn, ButtonGroup.fn);
        this.av = ThemeResolver.b(a, ButtonGroup.at, ButtonGroup.an);
        this.g3 = ThemeResolver.e(a, ButtonGroup.gr, ButtonGroup.fr);
        this.g0 = ThemeResolver.e(a, ButtonGroup.go, ButtonGroup.fo);
        this.g4 = ThemeResolver.e(a, ButtonGroup.gs, ButtonGroup.fs);
        this.g7 = ThemeResolver.e(a, ButtonGroup.gv, ButtonGroup.fv);
        this.g1 = ThemeResolver.e(a, ButtonGroup.gp, ButtonGroup.fp);
        this.g2 = ThemeResolver.e(a, ButtonGroup.gq, ButtonGroup.fq);
        this.g5 = ThemeResolver.e(a, ButtonGroup.gt, ButtonGroup.ft);
        this.g6 = ThemeResolver.e(a, ButtonGroup.gu, ButtonGroup.fu);
        this.aq = ThemeResolver.b(a, ButtonGroup.as, ButtonGroup.am);
        this.fw = ThemeResolver.e(a, ButtonGroup.f8, ButtonGroup.e8);
        this.fy = ThemeResolver.e(a, ButtonGroup.ga, ButtonGroup.fa);
        this.fx = ThemeResolver.e(a, ButtonGroup.f9, ButtonGroup.e9);
        this.fz = ThemeResolver.e(a, ButtonGroup.gb, ButtonGroup.fb);
        this.ap = ThemeResolver.b(a, ButtonGroup.ar, ButtonGroup.al);
        this.f3 = ThemeResolver.e(a, ButtonGroup.gf, ButtonGroup.ff);
        this.f0 = ThemeResolver.e(a, ButtonGroup.gc, ButtonGroup.fc);
        this.f4 = ThemeResolver.e(a, ButtonGroup.gg, ButtonGroup.fg);
        this.f7 = ThemeResolver.e(a, ButtonGroup.gj, ButtonGroup.fj);
        this.f1 = ThemeResolver.e(a, ButtonGroup.gd, ButtonGroup.fd);
        this.f2 = ThemeResolver.e(a, ButtonGroup.ge, ButtonGroup.fe);
        this.f5 = ThemeResolver.e(a, ButtonGroup.gh, ButtonGroup.fh);
        this.f6 = ThemeResolver.e(a, ButtonGroup.gi, ButtonGroup.fi);
    };
    Object.defineProperty(ButtonGroup.prototype, "ak", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.c7("ActualItemCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ew", {
        get: function () {
            return this.dj;
        },
        set: function (a) {
            var b = this.dj;
            this.dj = a;
            if (b != this.dj) {
                this.c7("ActualItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ey", {
        get: function () {
            return this.dl;
        },
        set: function (a) {
            var b = this.dl;
            this.dl = a;
            if (b != this.dl) {
                this.c7("ActualItemDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e3", {
        get: function () {
            return this.dr;
        },
        set: function (a) {
            var b = this.dr;
            this.dr = a;
            if (b != this.dr) {
                this.c7("ActualItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e0", {
        get: function () {
            return this.dn;
        },
        set: function (a) {
            var b = this.dn;
            this.dn = a;
            if (b != this.dn) {
                this.c7("ActualItemDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ex", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            var b = this.dk;
            this.dk = a;
            if (b != this.dk) {
                this.c7("ActualItemBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ez", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            var b = this.dm;
            this.dm = a;
            if (b != this.dm) {
                this.c7("ActualItemDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "aj", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (b != this.ab) {
                this.c7("ActualItemBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e4", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            var b = this.ds;
            this.ds = a;
            if (b != this.ds) {
                this.c7("ActualSelectedItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e7", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            var b = this.dv;
            this.dv = a;
            if (b != this.dv) {
                this.c7("ActualSelectedItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e1", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            var b = this.dp;
            this.dp = a;
            if (b != this.dp) {
                this.c7("ActualItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e2", {
        get: function () {
            return this.dq;
        },
        set: function (a) {
            var b = this.dq;
            this.dq = a;
            if (b != this.dq) {
                this.c7("ActualItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e5", {
        get: function () {
            return this.dt;
        },
        set: function (a) {
            var b = this.dt;
            this.dt = a;
            if (b != this.dt) {
                this.c7("ActualSelectedItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "e6", {
        get: function () {
            return this.du;
        },
        set: function (a) {
            var b = this.du;
            this.du = a;
            if (b != this.du) {
                this.c7("ActualSelectedItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "a0", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.c7("ItemCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hk", {
        get: function () {
            return this.d4;
        },
        set: function (a) {
            var b = this.d4;
            this.d4 = a;
            if (b != this.d4) {
                this.c7("ItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hm", {
        get: function () {
            return this.d6;
        },
        set: function (a) {
            var b = this.d6;
            this.d6 = a;
            if (b != this.d6) {
                this.c7("ItemDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hr", {
        get: function () {
            return this.eb;
        },
        set: function (a) {
            var b = this.eb;
            this.eb = a;
            if (b != this.eb) {
                this.c7("ItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ho", {
        get: function () {
            return this.d8;
        },
        set: function (a) {
            var b = this.d8;
            this.d8 = a;
            if (b != this.d8) {
                this.c7("ItemDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hp", {
        get: function () {
            return this.d9;
        },
        set: function (a) {
            var b = this.d9;
            this.d9 = a;
            if (b != this.d9) {
                this.c7("ItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hl", {
        get: function () {
            return this.d5;
        },
        set: function (a) {
            var b = this.d5;
            this.d5 = a;
            if (b != this.d5) {
                this.c7("ItemBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hn", {
        get: function () {
            return this.d7;
        },
        set: function (a) {
            var b = this.d7;
            this.d7 = a;
            if (b != this.d7) {
                this.c7("ItemDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "az", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            var b = this.af;
            this.af = a;
            if (b != this.af) {
                this.c7("ItemBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hq", {
        get: function () {
            return this.ea;
        },
        set: function (a) {
            var b = this.ea;
            this.ea = a;
            if (b != this.ea) {
                this.c7("ItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h4", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (b != this.es) {
                this.c7("SelectedItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h7", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (b != this.ev) {
                this.c7("SelectedItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h5", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (b != this.et) {
                this.c7("SelectedItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h6", {
        get: function () {
            return this.eu;
        },
        set: function (a) {
            var b = this.eu;
            this.eu = a;
            if (b != this.eu) {
                this.c7("SelectedItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "a2", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.c7("OutlinedItemCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hs", {
        get: function () {
            return this.ec;
        },
        set: function (a) {
            var b = this.ec;
            this.ec = a;
            if (b != this.ec) {
                this.c7("OutlinedItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hu", {
        get: function () {
            return this.ee;
        },
        set: function (a) {
            var b = this.ee;
            this.ee = a;
            if (b != this.ee) {
                this.c7("OutlinedItemDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hz", {
        get: function () {
            return this.ej;
        },
        set: function (a) {
            var b = this.ej;
            this.ej = a;
            if (b != this.ej) {
                this.c7("OutlinedItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hw", {
        get: function () {
            return this.eg;
        },
        set: function (a) {
            var b = this.eg;
            this.eg = a;
            if (b != this.eg) {
                this.c7("OutlinedItemDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hx", {
        get: function () {
            return this.eh;
        },
        set: function (a) {
            var b = this.eh;
            this.eh = a;
            if (b != this.eh) {
                this.c7("OutlinedItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ht", {
        get: function () {
            return this.ed;
        },
        set: function (a) {
            var b = this.ed;
            this.ed = a;
            if (b != this.ed) {
                this.c7("OutlinedItemBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hv", {
        get: function () {
            return this.ef;
        },
        set: function (a) {
            var b = this.ef;
            this.ef = a;
            if (b != this.ef) {
                this.c7("OutlinedItemDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "a1", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.c7("OutlinedItemBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hy", {
        get: function () {
            return this.ei;
        },
        set: function (a) {
            var b = this.ei;
            this.ei = a;
            if (b != this.ei) {
                this.c7("OutlinedItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h0", {
        get: function () {
            return this.eo;
        },
        set: function (a) {
            var b = this.eo;
            this.eo = a;
            if (b != this.eo) {
                this.c7("OutlinedSelectedItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h3", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            var b = this.er;
            this.er = a;
            if (b != this.er) {
                this.c7("OutlinedSelectedItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h1", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (b != this.ep) {
                this.c7(ButtonGroup.cs, b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "h2", {
        get: function () {
            return this.eq;
        },
        set: function (a) {
            var b = this.eq;
            this.eq = a;
            if (b != this.eq) {
                this.c7("OutlinedSelectedItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ay", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.c7("FlatItemCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "g8", {
        get: function () {
            return this.dw;
        },
        set: function (a) {
            var b = this.dw;
            this.dw = a;
            if (b != this.dw) {
                this.c7("FlatItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ha", {
        get: function () {
            return this.dy;
        },
        set: function (a) {
            var b = this.dy;
            this.dy = a;
            if (b != this.dy) {
                this.c7("FlatItemDisabledBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hf", {
        get: function () {
            return this.d3;
        },
        set: function (a) {
            var b = this.d3;
            this.d3 = a;
            if (b != this.d3) {
                this.c7("FlatItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hc", {
        get: function () {
            return this.d0;
        },
        set: function (a) {
            var b = this.d0;
            this.d0 = a;
            if (b != this.d0) {
                this.c7("FlatItemDisabledTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hd", {
        get: function () {
            return this.d1;
        },
        set: function (a) {
            var b = this.d1;
            this.d1 = a;
            if (b != this.d1) {
                this.c7("FlatItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "g9", {
        get: function () {
            return this.dx;
        },
        set: function (a) {
            var b = this.dx;
            this.dx = a;
            if (b != this.dx) {
                this.c7("FlatItemBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hb", {
        get: function () {
            return this.dz;
        },
        set: function (a) {
            var b = this.dz;
            this.dz = a;
            if (b != this.dz) {
                this.c7("FlatItemDisabledBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "ax", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.c7("FlatItemBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "he", {
        get: function () {
            return this.d2;
        },
        set: function (a) {
            var b = this.d2;
            this.d2 = a;
            if (b != this.d2) {
                this.c7("FlatItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hg", {
        get: function () {
            return this.ek;
        },
        set: function (a) {
            var b = this.ek;
            this.ek = a;
            if (b != this.ek) {
                this.c7("FlatSelectedItemBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hj", {
        get: function () {
            return this.en;
        },
        set: function (a) {
            var b = this.en;
            this.en = a;
            if (b != this.en) {
                this.c7("FlatSelectedItemTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hh", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (b != this.el) {
                this.c7("FlatSelectedItemHoverBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "hi", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (b != this.em) {
                this.c7("FlatSelectedItemHoverTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (b != this.p) {
                this.c7("Orientation", enumGetBox(ButtonGroupOrientation_$type, b), enumGetBox(ButtonGroupOrientation_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "b2", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.c7("Id", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "disabled", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            this.u = true;
            if (b != this.v) {
                this.c7("IsDisabled", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "y", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.c7("IsMultiSelect", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.prototype.c8 = function () {
    };
    ButtonGroup.prototype.onDetachedFromUI = function () {
        this.view.r();
    };
    ButtonGroup.prototype.onAttachedToUI = function () {
        this.view.p();
    };
    ButtonGroup.prototype.aa = function () {
        return this.view.d();
    };
    ButtonGroup.prototype.provideContainer = function (a) {
        this.view.q(a);
    };
    Object.defineProperty(ButtonGroup.prototype, "buttons", {
        get: function () {
            return this.l;
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.$t = markType(ButtonGroup, 'ButtonGroup', Base.$, [INotifyPropertyChanged_$type]);
    ButtonGroup.f = 2;
    ButtonGroup.au = 4;
    ButtonGroup.gk = BrushUtil.g(255, 255, 255, 255);
    ButtonGroup.gm = BrushUtil.g(10, 0, 0, 0);
    ButtonGroup.gl = BrushUtil.g(255, 199, 199, 199);
    ButtonGroup.gn = BrushUtil.g(255, 199, 199, 199);
    ButtonGroup.at = 1;
    ButtonGroup.gr = BrushUtil.g(255, 0, 0, 0);
    ButtonGroup.go = BrushUtil.g(66, 0, 0, 0);
    ButtonGroup.gs = BrushUtil.g(60, 0, 0, 0);
    ButtonGroup.gv = BrushUtil.g(255, 0, 0, 0);
    ButtonGroup.gp = BrushUtil.g(30, 0, 0, 0);
    ButtonGroup.gq = BrushUtil.g(255, 0, 0, 0);
    ButtonGroup.gt = BrushUtil.g(96, 0, 0, 0);
    ButtonGroup.gu = BrushUtil.g(255, 0, 0, 0);
    ButtonGroup.ao = 3;
    ButtonGroup.fk = BrushUtil.g(0, 255, 255, 255);
    ButtonGroup.fm = BrushUtil.g(10, 0, 0, 0);
    ButtonGroup.fl = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.fn = BrushUtil.g(255, 199, 199, 199);
    ButtonGroup.an = 1;
    ButtonGroup.fr = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.fo = BrushUtil.g(66, 0, 0, 0);
    ButtonGroup.fs = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.fv = BrushUtil.g(255, 255, 255, 255);
    ButtonGroup.fp = BrushUtil.g(26, 33, 150, 243);
    ButtonGroup.fq = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.ft = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.fu = BrushUtil.g(255, 255, 255, 255);
    ButtonGroup.as = 4;
    ButtonGroup.f8 = BrushUtil.g(0, 255, 255, 255);
    ButtonGroup.ga = BrushUtil.g(10, 0, 0, 0);
    ButtonGroup.f9 = BrushUtil.g(0, 0, 0, 0);
    ButtonGroup.gb = BrushUtil.g(255, 199, 199, 199);
    ButtonGroup.ar = 0;
    ButtonGroup.gf = BrushUtil.g(255, 228, 28, 119);
    ButtonGroup.gc = BrushUtil.g(66, 0, 0, 0);
    ButtonGroup.gg = BrushUtil.g(30, 228, 28, 119);
    ButtonGroup.gj = BrushUtil.g(255, 228, 28, 119);
    ButtonGroup.gd = BrushUtil.g(13, 228, 28, 119);
    ButtonGroup.ge = BrushUtil.g(255, 228, 28, 119);
    ButtonGroup.gh = BrushUtil.g(30, 228, 28, 119);
    ButtonGroup.gi = BrushUtil.g(255, 228, 28, 119);
    ButtonGroup.am = 0;
    ButtonGroup.e8 = BrushUtil.g(0, 255, 255, 255);
    ButtonGroup.fa = BrushUtil.g(10, 0, 0, 0);
    ButtonGroup.e9 = BrushUtil.g(0, 0, 0, 0);
    ButtonGroup.fb = BrushUtil.g(0, 0, 0, 0);
    ButtonGroup.al = 0;
    ButtonGroup.ff = BrushUtil.g(255, 119, 119, 119);
    ButtonGroup.fc = BrushUtil.g(66, 0, 0, 0);
    ButtonGroup.fg = BrushUtil.g(26, 33, 150, 243);
    ButtonGroup.fj = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.fd = BrushUtil.g(10, 33, 150, 243);
    ButtonGroup.fe = BrushUtil.g(255, 119, 119, 119);
    ButtonGroup.fh = BrushUtil.g(26, 33, 150, 243);
    ButtonGroup.fi = BrushUtil.g(255, 33, 150, 243);
    ButtonGroup.cs = "OutlinedSelectedItemHoverBackgroundColor";
    ButtonGroup.a3 = 0;
    return ButtonGroup;
}(Base));
export { ButtonGroup };
//# sourceMappingURL=ButtonGroupView_combined.js.map
